"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Paddling as Bib Number");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Name");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Club");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Year of Birth");
class NonRankedPaddler extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_setValue", (field, value) => {
      this.props.setValue(field, value);
    });
    _defineProperty(this, "_validateBibName", value => {
      if (value && this.props.cseBibsByClassDivision.some(bib => bib.bibName.toUpperCase() === value.toUpperCase())) {
        return 'bibName', 'This name corresponds to a ranked paddler, select ranked paddler in list above';
      }
      return '';
    });
    _defineProperty(this, "_validateBib", value => {
      if (this.props.cseBibsByClassDivision.some(bib => +bib.bibNumber === +value)) {
        return 'startListBib', 'Bib number in use by ranked paddler, select ranked paddler or use another number';
      }
      return '';
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Integer",
      name: "startListBib",
      value: this.props.newEntry.startListBib,
      onChange: this._setValue.bind(this, 'startListBib'),
      maxLength: 5,
      required: true,
      customValidation: this._validateBib
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "bibName",
      value: this.props.newEntry.bibName,
      onChange: this._setValue.bind(this, 'bibName'),
      maxLength: 100,
      required: true,
      customValidation: this._validateBibName
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "PaddlerClubs",
      value: this.props.newEntry.paddlerClubID,
      onChange: this._setValue.bind(this, 'paddlerClubID'),
      clearable: true,
      yearID: this.props.yearID
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Year",
      name: "yearOfBirth",
      value: this.props.newEntry.yearOfBirth,
      onChange: this._setValue.bind(this, 'yearOfBirth'),
      maxLength: 4
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = {
  id: true,
  bibNumber: true,
  bibName: true
};
var _default = exports.default = (0, _reactBicycle.connect)(NonRankedPaddler, props => {
  if (!props.newEntry) return {};
  return {
    ["cseBibsByClassDivision(classDivisionID:" + JSON.stringify(props.newEntry.classDivisionID) + ",yearID:" + JSON.stringify(props.yearID) + ")"]: _ref5
  };
});